// Rule-based insight generator. No AI.
export function getInsight({ mood, energy, sleep, hydration }, isPremium = false) {
  const sleepNum = parseFloat(sleep);
  const messages = [];

  // Sleep + mood combo
  if (!isNaN(sleepNum) && sleepNum > 0 && sleepNum < 6 && mood !== null && mood <= 2) {
    messages.push("Low sleep paired with low mood often amplifies each other. Be gentle with your expectations today — a 10-minute walk in daylight can reset both.");
  } else if (!isNaN(sleepNum) && sleepNum > 0 && sleepNum < 6) {
    messages.push("Less than 6 hours of sleep tends to lower patience and focus. Plan one small task, not three big ones.");
  }

  // Hydration
  if (hydration !== null && hydration < 3) {
    messages.push("Hydration looks light today. A glass of water before your next task is a 30-second nervous-system reset.");
  }

  // Energy
  if (energy !== null && energy <= 2 && (isNaN(sleepNum) || sleepNum >= 6)) {
    messages.push("Low energy without low sleep can be an emotional load, not a physical one. Ask: what am I carrying that isn't mine?");
  }

  // Mood positive
  if (mood !== null && mood >= 4 && energy !== null && energy >= 4) {
    messages.push("You're in a strong window. Use 10 minutes on the thing you've been postponing — momentum compounds.");
  }

  // Default
  if (messages.length === 0 && (mood !== null || energy !== null || sleep || hydration > 0)) {
    messages.push("Logged. Patterns become visible after a few days — keep checking in.");
  }

  if (!isPremium) {
    return messages[0] || null;
  }
  return messages.join(" ") || null;
}
